<script>
import {defineComponent, reactive} from 'vue'
import {Connection, StakeProgram, Transaction, VersionedTransaction, VersionedMessage} from "@solana/web3.js";
import {useWallet} from "solana-wallets-vue";
import collect from 'collect.js'

const HEALTH_THRESHOLD = 98 // change to 80ish for production
const REF_CODE = 'vq2umxqn'

const connection = new Connection(window.swapConfig?.rpcEndpoint || 'https://api.mainnet-beta.solana.com', {
    commitment: 'confirmed',
    confirmTransactionInitialTimeout: 12000
});

export default defineComponent({
    name: "StakingHealthcheck",
    data() {
        return {
            // wallet: null,
            // walletConnected: false,
            stakeAccounts: [],
            loadingAccounts: false,
            validatorScores: [],
            selected:[]
        }
    },
    mounted() {
        this.wallet = useWallet()
        this.walletConnected = this.wallet.connected
        this.loadValidatorScores()
        this.getStakeAccounts()
    },
    methods: {
        async getStakeAccounts() {
            if (!this.walletConnected) {
                return
            }

            // eslint-disable-next-line
            console.log('getting stake accounts')
            let stakeAccountInfo = await connection.getParsedProgramAccounts(
                StakeProgram.programId,
                {
                    filters: [
                        {
                            memcmp: {
                                offset: 44,
                                bytes: this.wallet.publicKey.toString()
                            },
                        },
                        {
                            dataSize: 200
                        }
                    ]
                }
            )

            this.stakeAccounts = stakeAccountInfo
            console.log('retrieved stake accounts', this.stakeAccounts)
            setTimeout(() => { this.$refs.atRiskAccounts.selectAllRows(); console.log('selectall',this.selected) } , 1000)
            this.loadingAccounts = false
        },
        getStakeAccountBalanceSol(account) {
            let stake = account?.account?.data?.parsed?.info?.stake?.delegation?.stake
            if (!stake) stake = account.account.lamports - account.account.data?.parsed?.info?.meta?.rentExemptReserve
            return stake / 1e9
        },
        loadValidatorScores() {
            axios.get('/validators').then((response) => {
                this.validatorScores = {}
                for(let v_id in response.data) {
                    let validator = response.data[v_id]
                    this.validatorScores[validator.vote_account] = validator
                }
                // console.log('validator scores', this.validatorScores)
            })
        },
        onRowSelected(item) {
            console.log('select',item)
            this.selected.push(item)
        },
        onRowDeselected(item) {
            console.log('deselect',item)
            this.selected = this.selected.filter((account) => {
                return account.account.pubkey != item.account.pubkey
            })
        },
        async getNativeInstruction(pubkey) {
            return axios.get('https://native-staking-referral.marinade.finance/v1/tx/deposit-stake-account?code=' + REF_CODE + '&stake=' + pubkey + '&user=' + this.wallet.publicKey)
        },
        async fixStakes() {
            // get all promises from getNativeInstruction for each selected account
            // console.log(this.selected)
            let promises = this.selected.map((account) => {
                return this.getNativeInstruction(account.account.pubkey)
            })
            // await all promises
            let results = await Promise.all(promises)
            // get all txs from results ( {"serializedTx":"string"} )
            // console.log(results)
            let first = results.shift()
            const txn = VersionedTransaction.deserialize( Buffer.from(first.data.serializedTx))

            let instructions = results.map((result) => {
                let serialized = result.data.serializedTx
                let tx = VersionedTransaction.deserialize( Buffer.from(serialized, 'base64'))
                console.log(tx)
                txn.add(tx.instructions)
                return tx.instructions
            })
            // console.log(txs)
            // send all txs
            let txids = await this.wallet.sendTransaction(txs, connection)

        }
    },
    watch: {

        walletConnected(now, prev) {
            console.log('wallet changed')
            if (this.wallet.connected) {
                this.getStakeAccounts()
                // this.clicky('/dashboard/wallet-connected')
            } else {
                this.balances = {}
                this.balance = 0
                // this.clicky('/dashboard/wallet-disconnected')

            }

        },
    },
    computed: {
        wallet() {
            return reactive(useWallet())
        },
        walletAddress() {
            return this.wallet.address
        },
        walletConnected() {
            return this.wallet.connected
        },
        enrichedAccounts() {
            return  collect(this.stakeAccounts).map((account) => {
                let balance = this.getStakeAccountBalanceSol(account)
                let voteKey = account.account.data.parsed.info.stake?.delegation?.voter
                let validator = this.validatorScores[voteKey] || {}
                let score_percent = validator.score_percent || 0
                return {
                    account: account,
                    pubkey: account.pubkey,
                    balance: balance,
                    voteKey: voteKey,
                    validator: validator,
                    score_percent: score_percent,
                }
            })
        },
        atRisk() {
            return this.enrichedAccounts.filter((account) => {
                return account.score_percent < HEALTH_THRESHOLD
            })
        },
        atRiskBalance() {
            return this.atRisk.sum('account.balance')
        },
        atRiskCount() {
            return this.atRisk.count()
        },
        atRiskPercent() {
            return this.atRiskBalance / this.totalBalance
        },
        totalBalance() {
            return collect(this.stakeAccounts).sum((account) => {
                return this.getStakeAccountBalanceSol(account)
            })
        },
        totalStakeAccounts() {
            return this.stakeAccounts.length
        },
        totalStakeAccountsBalance() {
            return collect(this.stakeAccounts).sum((account) => {
                return this.getStakeAccountBalanceSol(account)
            })
        },
        goodAccounts() {
            return this.enrichedAccounts.filter((account) => {
                return account.score_percent >= HEALTH_THRESHOLD
            })
        },
    }

})
</script>

<template>
<div class="row justify-content-center">
    <div class="sm-w-50 mx-auto my-5">
        <h1 class="display-1">🚑<br><span class="display-6">Stake Health Check</span></h1>
        <p class="lead" v-if="!wallet.connected">Please connect your wallet to check your stake accounts</p>
    </div>
</div>

<div class="row justify-content-center" v-if="atRiskCount">
    <div class="card">
        <div class="card-header bg-danger text-white">{{ atRiskCount }} Unhealthy Stake Accounts Totalling {{ atRiskBalance.toFixed(4) }} SOL</div>
        <div class="card-body">
            <h3>Fix staking issues</h3>
            <button class="btn btn-success btn-xl " @click="fixStakes">Fix My Stake Accounts</button>
            <p class="lead">We can help you improve your stake performance by automatically redelegating your stake to our validator, or by distributing your stake with Marinade's network of >100 high quality validators as either native or liquid stake.</p>
            <p class="lead">We've automatically chosen your underperforming accounts but you can make changes to the list below. Common issues can include poor decentralization, regular downtime nad low APY performance.</p>

            <b-table selectable card :items="atRisk" ref="atRiskAccounts"
                     :fields="[
                        {key: 'validator.avatar_url', label: ''},
                        {key: 'validator.name', label: 'Validator'},
                         {key: 'pubkey', label: 'Pubkey'},
                         {key: 'balance', label: 'Balance'},
                         {key: 'score_percent', label: 'Score'},
                     ]"
                     @row-selected="onRowSelected"
                     @row-unselected="onRowDeselected"
                     select-mode="multi"

            >
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>
                <template #cell(validator.avatar_url)="data">
                    <img :src="data.item.validator.avatar_url" width="32" height="32" class="rounded-circle" v-if="data.item?.validator?.avatar_url"/>
                </template>
                <template #cell(validator.name)="data">
                    <span v-if="data.item.validator?.name">{{ data.item.validator.name }}</span>
                    <span v-else>Unknown</span>
                </template>
                <template #cell(pubkey)="data">
                    <a :href="`https://explorer.solana.com/address/${data.item.pubkey}`" target="_blank">{{ String(data.item.pubkey).substring(0,3) }}...{{ String(data.item.pubkey).substring(String(data.item.pubkey).length-3) }}</a>
                </template>
                <template #cell(balance)="data">
                    {{ data.item.balance.toFixed(4) }} SOL
                </template>
                <template #cell(score_percent)="data">
                    <div :class="{
                        'text-danger lead': data.item.score_percent < HEALTH_THRESHOLD,
                        'text-success lead': data.item.score_percent >= HEALTH_THRESHOLD
                    }">
                        <a :href="'/validators/' + data.item.validator.account" target="_blank">{{ data.item.score_percent.toFixed(2) }}%</a>
                    </div>
                </template>
            </b-table>


        </div>
    </div>
</div>
</template>

<style scoped>

</style>
